<template>
  <div
    v-if="src"
    class="entity-icon"
    :style="{ width: `${width}px`, height: `${height}px` }"
  >
    <img
      alt="Entity Icon"
      crossorigin="anonymous"
      :height="height"
      :src="src"
      :width="width"
    >
  </div>
</template>

<script>
export default {
  name: 'EntityImage',
  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
}
</script>

<style scoped>
.entity-icon {
  display: flex;
  flex-shrink: 0;
  border-radius: 100%;
  overflow: hidden;
}
.entity-icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
